














import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import BaseComponent from '@/components/base-component.vue';

@Component
export default class PrescriptionAlertsMessages extends BaseComponent {
  @Prop()
  public title?: string;
  @Prop()
  public message?: string;
  @Prop()
  public status?: 'warning' | 'error' | 'empty' | 'success';
  @Prop()
  public count?: string;
}
